import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/api/query-keys'
import { fetchSensemakerList } from './sensemaker-list.api'

export function useSensemakerList() {
  return useQuery({
    queryKey: queryKeys.tenants.list(),
    queryFn: fetchSensemakerList,
  })
}
